import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { PurchaseTypeSelectorDS } from './purchase-type-selector-ds'
import { PurchaseTypeSelectorLegacy } from './purchase-type-selector-legacy'
import { PurchaseTypeSelectorShimmerDS } from './purchase-type-selector-shimmer-ds'
import { PurchaseTypeSelectorShimmerLegacy } from './purchase-type-selector-shimmer-legacy'

import type { PurchaseTypeSelectorProps, PurchaseTypeSelectorShimmerProps } from './purchase-type-selector.types'

export { PURCHASE_TYPES } from './purchase-type-selector.types'
export type { PurchaseType, PurchaseTypeSelectorProps } from './purchase-type-selector.types'
export { getDefaultPlanId } from './purchase-type-selector.helpers'

export const PurchaseTypeSelectorShimmer = (props: PurchaseTypeSelectorShimmerProps) => {
  if (shouldUseDesignSystem()) {
    return <PurchaseTypeSelectorShimmerDS {...props} />
  }
  return <PurchaseTypeSelectorShimmerLegacy {...props} />
}

const PurchaseTypeSelector = (props: PurchaseTypeSelectorProps) => {
  if (shouldUseDesignSystem()) {
    return <PurchaseTypeSelectorDS {...props} />
  }
  return <PurchaseTypeSelectorLegacy {...props} />
}

export default PurchaseTypeSelector
